import styled from 'styled-components'

export const StyledStartButt = styled.button`
  background: #333333;
  border: none;
  border-radius: 20px;
  box-sizing: border-box;
  color: white;
  cursor: pointer;
  font-family: Pixel, Arial, Helvetica, sans-serif;
  font-size: 1rem;
  margin: 0 0 20px 0;
  min-height: 30px;
  outline: none;
  padding: 20px;
  width: 100%;
`